module.exports = __webpack_public_path__ + "img/pro-p-slider22.ed7cc0de.png";